import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useEffect } from 'react';

type UseReportBannerVisibility = (shouldShowBanner: boolean) => void;
export const useReportBannerVisibility: UseReportBannerVisibility = (shouldShowBanner) =>
  useEffect(() => {
    reportUsage({
      eventName: shouldShowBanner
        ? AnalyticsEventName.DeprecationBannerLoaded
        : AnalyticsEventName.DeprecationBannerHidden,
    });
  }, [shouldShowBanner]);
